export enum ECalendarWeekdayFormat {
  long = 'long',
  short = 'short',
  narrow = 'narrow',
}

export enum ECalendarMonthFormat {
  numeric = 'numeric',
  twoDigit = '2-digit',
  long = 'long',
  short = 'short',
  narrow = 'narrow',
}

export enum ECalendarDayFormat {
  numeric = 'numeric',
  twoDigit = '2-digit',
}

export enum ECalendarYearFormat {
  numeric = 'numeric',
  twoDigit = '2-digit',
}

export enum ECalendarHourFormat {
  numeric = 'numeric',
  twoDigit = '2-digit',
}

export enum ECalendarMeridiemFormat {
  lowercase = 'lowercase',
  short = 'short',
  narrow = 'narrow',
}

export enum ECalendarViewsId {
  resourceTimelineYear = 'resourceTimelineYear',
  resourceTimelineMonth = 'resourceTimelineMonth',
  resourceTimelineWeek = 'resourceTimelineWeek',
}

export enum EHeaderToolbar {
  title = 'title',
  prev = 'prev',
  next = 'next',
  prevYear = 'prevYear',
  nextYear = 'nextYear',
  today = 'today',
}

export enum EHeaderToolbarDirections {
  prev = 'prev',
  next = 'next',
  today = 'today',
}

export enum ECalendarEventType {
  defaultAssembly = 'DEFAULT_ASSEMBLY',
  scheduleComponent = 'SCHEDULE_COMPONENT',
}

export enum CALENDAR_TAB_VALUES {
  EVENT_CONTENT = '1',
  BACKUP = '2',
}

export type CalendarToolbarDirection = 'prev' | 'next' | 'today';
